/**
 * Generate a consistent color based on asset ID.
 * This ensures the same asset always gets the same color.
 * 
 * @param {string} assetId - The asset ID to generate a color for
 * @returns {string} - A hex color code
 */
export const generateColorForAsset = (assetId) => {
  // Pre-defined palette of distinct, visually appealing colors
  const colorPalette = [
    '#3498db', // Blue
    '#e74c3c', // Red
    '#2ecc71', // Green
    '#9b59b6', // Purple
    '#f39c12', // Orange
    '#1abc9c', // Teal
    '#d35400', // Pumpkin
    '#8e44ad', // Violet
    '#27ae60', // Emerald
    '#e67e22', // Carrot
    '#16a085', // Green Sea
    '#c0392b', // Pomegranate
    '#2980b9', // Belize Hole
    '#f1c40f', // Sunflower
    '#7f8c8d', // Asbestos
    '#34495e', // Wet Asphalt
  ];
  
  // Hash function to convert assetId to a consistent index
  let hash = 0;
  for (let i = 0; i < assetId.length; i++) {
    hash = assetId.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Use the hash to select a color from our palette
  const index = Math.abs(hash) % colorPalette.length;
  return colorPalette[index];
};

// Alternative color generation if you need more colors than in the palette
export const generateFallbackColor = (assetId) => {
  // Simple hash function for the asset ID
  let hash = 0;
  for (let i = 0; i < assetId.length; i++) {
    hash = assetId.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Convert hash to hex color
  const c = (hash & 0x00FFFFFF)
    .toString(16)
    .toUpperCase()
    .padStart(6, '0');
    
  return `#${c}`;
};